import React from 'react'
import styled from 'styled-components'
import { FeedbackRating } from './FeedbackRating'
import { Block, Button, TextArea } from '@mote/ui'
import { useTrackMutation } from '@mote/api'
import { WEB_STORAGE_PREFIX_KEYS } from '@mote/helpers/constants'
import { isMobile } from '@mote/helpers/browser'

export function FeedbackForm({ event, cohort, sendToNativeForm, loading }) {
  const [selectedEmoji, setSelectedEmoji] = React.useState('')
  const [feedbackMessage, setFeedbackMessage] = React.useState('')
  const [rating, setRating] = React.useState(null)

  const { mutate: track } = useTrackMutation()

  function handleFeedbackEmojiSelection(emoji, rating) {
    setSelectedEmoji(emoji)
    setRating(rating)
    track({
      variables: {
        event,
        rating
      }
    })
  }

  function handleFeedbackMessageChange(e) {
    setFeedbackMessage(e.target.value)
  }

  function handleFormSubmission() {
    const isMinor = window.localStorage.getItem(
      `${WEB_STORAGE_PREFIX_KEYS}isMinor`
    )
    const primaryEmailAddress =
      isMinor === 'true'
        ? ''
        : window.localStorage.getItem(
            `${WEB_STORAGE_PREFIX_KEYS}primaryEmailAddress`
          )
    const isMobileStr = isMobile().toString()

    sendToNativeForm({
      variables: {
        airtableBaseId: 'appUWp3AhQ85Xz9eu',
        airtableTableId: window.location.origin.includes('www')
          ? 'tbl2BDY7cjEdFgCLM'
          : 'tbl4YVkVBxOAVPQCI',
        formData: {
          rating,
          isMinor,
          primaryEmailAddress,
          comment: feedbackMessage,
          creatorCohort: cohort,
          mobileDevice: isMobileStr,
          isInstitutional: window.localStorage.getItem(
            `${WEB_STORAGE_PREFIX_KEYS}isInstitutional`
          ),
          userId: window.localStorage.getItem(
            `${WEB_STORAGE_PREFIX_KEYS}userId`
          ),
          anonymousUserId: window.localStorage.getItem(
            `${WEB_STORAGE_PREFIX_KEYS}anonymousUserId`
          )
        }
      }
    })
  }

  return (
    <Root gap={25} align='center'>
      <FeedbackRating
        emojiSelected={selectedEmoji}
        onFeedbackEmojiSelection={handleFeedbackEmojiSelection}
      />
      {selectedEmoji && (
        <>
          <TextArea
            maxWidth={300}
            rows={5}
            value={feedbackMessage}
            onChange={handleFeedbackMessageChange}
            placeholder='Type here...'
          />

          <Button
            disabled={feedbackMessage.length === 0 || loading}
            loading={loading}
            loadingText='Submitting...'
            text='Submit feedback'
            onClick={handleFormSubmission}
          />
        </>
      )}
    </Root>
  )
}

const Root = styled(Block)``
